
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13445',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13445",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1075",
  "client-types": "static-1.507",
  "data-fetching-client": "static-1.10079",
  "foundations-components": "static-1.8684",
  "foundations-components-legacy": "static-1.1709",
  "foundations-theming": "static-1.4920",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.93",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8473",
  "hub-http-shared-msw-handlers": "static-1.10836",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11928",
  "I18n": "static-7.1698",
  "jasmine-runner": "static-1.6886",
  "marketplace-discovery-studio-lib": "static-1.842",
  "marketplace-storefront-base": "static-1.13508",
  "quartz": "static-1.7613",
  "react-dlb": "static-1.93",
  "react-rhumb": "static-1.17170",
  "reactive-variable-buffer-atom": "static-1.3287",
  "reporting-testing-lib": "static-1.11177",
  "reselect": "static-3.16",
  "settings-ui-lib": "static-1.12965",
  "SharedI18nStrings": "static-1.187",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7793",
  "ui-addon-i18n": "static-1.11580",
  "ui-addon-react-router-dom": "static-1.9963",
  "unified-auth": "static-1.1168",
  "unified-auth-core-lib": "static-1.1450",
  "usage-tracker": "static-1.7748",
  "usage-tracker-core": "static-1.7598",
  "customer-data-property-utils": "static-1.8481",
  "hub-http": "static-1.6644",
  "integrations-lib": "static-1.17333",
  "marketplace-ui-common": "static-1.20985",
  "marketplace-ui-install": "static-1.971",
  "property-management-iframe": "static-1.14384",
  "quartz-config": "static-1.1391",
  "quartz-core": "static-1.6832",
  "quartz-routing": "static-1.1043",
  "quick-fetch": "static-1.4205",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5106",
  "ts-schema": "static-1.4375",
  "ui-universal-auth": "static-1.9654",
  "UIComponents": "static-3.8874",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3890",
  "quartz-webpack": "static-1.3837",
  "bend-plugin-quartz-routing": "static-1.691",
  "ai-components-ui-library": "static-1.9952",
  "codemirror": "static-5.106",
  "foundations-assets": "static-1.5321",
  "pulse": "static-1.1077",
  "react-codemirror": "static-1.11075",
  "ui-extensions-preview-lib": "static-1.871",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4953",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2636",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9860",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.96",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5636",
  "react-virtualized": "static-2.111",
  "StyleGuideUI": "static-3.514",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2997",
  "ui-fonts": "static-1.1190",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-theming": "static-1.3403",
  "foundations-theming-base": "static-1.3905",
  "stylex": "static-1.46",
  "HeadJS": "static-2.817",
  "hs-test-utils-bend-plugin": "static-1.3584",
  "msw": "static-1.102",
  "msw-config": "static-1.24",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4743",
  "ui-addon-video-player": "static-1.9059",
  "ai-rendering-library": "static-1.11334",
  "chirp-fetch": "static-1.2338",
  "connections-embed-lib": "static-1.1686",
  "copilot-toolkit": "static-1.12076",
  "feedback-loader": "static-1.30001",
  "laboratory-lib": "static-3.7585",
  "marketplace-embed": "static-1.23136",
  "marketplace-ui-details": "static-1.10880",
  "marketplace-ui-reviews": "static-1.20940",
  "marketplace-ui-tracking": "static-1.15155",
  "sanitize-text": "static-1.8592",
  "usage-tracker-multi": "static-1.6162",
  "usage-tracker-session-replay": "static-1.5434",
  "wootric-nps": "static-1.7276",
  "quartz-head": "static-1.1278",
  "web-vitals": "static-1.19",
  "apollo-link-hub-http": "static-2.5023",
  "immer": "static-1.105",
  "immerable": "static-1.4577",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2799",
  "reporting-data": "static-1.69244",
  "cssUtils": "static-1.1056",
  "flux-actions": "static-1.380",
  "react-colorpicker": "static-2.10646",
  "react-dnd-compat": "static-1.5044",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10806",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7738",
  "icons": "static-2.699",
  "marketplace-ui-apps-core": "static-1.19517",
  "storybook-react": "static-1.44",
  "trellis-story-utils": "static-1.4936",
  "foundations-components-test-utils": "static-1.6167",
  "quartz-i18n": "static-1.1288",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.700",
  "ads-unified-auth-lib": "static-1.1827",
  "custom-vendor-connection-lib": "static-1.218",
  "google-sheets-integration-lib": "static-1.1265",
  "microsoft-drive-auth-lib": "static-1.426",
  "slack-ui-library": "static-1.10833",
  "surveymonkey-integration-lib": "static-1.792",
  "fsm": "static-1.4194",
  "customer-data-objects": "static-1.8129",
  "property-translator": "static-1.5814",
  "hs-locale-management": "static-1.375",
  "frontend-preferences-client": "static-1.8353",
  "hs-promise-utils": "static-1.6028",
  "hubspot-apollo-client": "static-1.5314",
  "integrations-error-boundary-lib": "static-1.14748",
  "integrations-tracking-lib": "static-1.6048",
  "native-integrations-shared-strings": "static-1.8198",
  "sanitize": "static-1.4909",
  "superstore": "static-1.5193",
  "ui-shepherd-react": "static-3.10710",
  "ai-settings-ui-library": "static-1.8520",
  "hub-http-janus": "static-1.902",
  "hubspotter-http": "static-1.4950",
  "immutable-less": "static-1.5087",
  "marketplace-ui-client-types": "static-1.18392",
  "nav-meta": "static-1.30729",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18525",
  "ui-product-approvals-common": "static-1.1482",
  "ai-studio-lib": "static-1.12688",
  "hubspot-prosemirror": "static-1.19214",
  "integrations-reconnect-lib": "static-1.659",
  "ui-addon-iframeable": "static-1.9512",
  "ui-addon-integrations-directory-panel": "static-2.8390",
  "ui-product-approvals": "static-1.29587",
  "ui-tool-access": "static-1.10593",
  "inbound-db-properties-service-client": "static-1.4125",
  "property-management-common": "static-1.6672",
  "opentelemetry-fe-types": "static-1.222",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.600",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.597",
  "quartz-auth": "static-1.1288",
  "quartz-test": "static-1.1288",
  "quartz-tracking": "static-1.992",
  "trellis-components": "static-1.3016",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.516",
  "HubStyle": "static-2.12235",
  "bender-build-tools": "static-1.3518",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23607",
  "ContentUtils": "static-1.69390",
  "customer-data-objects-ui-components": "static-1.13464",
  "sassPrefix": "static-1.324",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.1982",
  "bend-plugin-pulse": "static-1.580",
  "event-emitter": "static-1.1396",
  "fast-json-patch": "static-1.74",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5874",
  "magpie-types": "static-1.5334",
  "stylex-utils": "static-1.168",
  "trellis-theming": "static-1.1422",
  "avatar-components": "static-1.2919",
  "breeze-engine-core": "static-1.1324",
  "breeze-onboarding-components": "static-1.994",
  "customer-data-filters-ui": "static-1.41265",
  "customer-data-reference-ui-components": "static-1.13601",
  "data-integrations-breeze": "static-1.237",
  "embedded-academy-lib": "static-1.15910",
  "ExportDialog": "static-6.10806",
  "global-styles-ai-lib": "static-1.426",
  "highlight.js": "static-1.90",
  "marketplace-embed-ba": "static-1.839",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.44",
  "reporting-action-components": "static-1.42308",
  "reporting-snowflake": "static-1.57860",
  "reporting-ui-components": "static-2.66513",
  "reporting-visualizations": "static-1.61318",
  "trial-components-library": "static-1.14316",
  "ui-addon-teams": "static-1.21971",
  "upgrade-components-lib": "static-1.676",
  "navigation-components": "static-1.19092",
  "breeze-engine-lib": "static-1.2046",
  "simple-logging-lib": "static-1.3488",
  "nudge-client-utils": "static-1.3352",
  "fail-safe": "static-1.387",
  "app-governance-lib": "static-1.2625",
  "developer-experience-shared-components": "static-1.10974",
  "purchase-motions-components": "static-1.6583",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10669",
  "usage-tracker-anonymous": "static-1.6165",
  "usage-tracker-public": "static-1.7559",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3753",
  "persist-promise": "static-1.4139",
  "reference-resolvers": "static-1.8614",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4351",
  "hubspot-apollo-cache": "static-1.773",
  "universal-page-editor-lib": "static-1.3444",
  "final-form": "static-1.82",
  "redux-toolkit": "static-1.82",
  "simple-data-table": "static-1.3760",
  "merchandise-lib": "static-1.283",
  "onboarding-scopes": "static-1.6888",
  "ui-addon-draggable": "static-3.5183",
  "content-assistance-lib": "static-1.8366",
  "content-media-capture": "static-1.5716",
  "customer-data-ui-utilities": "static-1.10268",
  "emoji-mart": "static-3.6",
  "file-manager-components": "static-1.24772",
  "growth-payments-core": "static-1.26433",
  "knowledge-content-types": "static-1.8722",
  "PatternValidationJS": "static-1.3321",
  "payment-link-components": "static-1.24374",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20494",
  "ui-addon-emoji-picker": "static-1.10300",
  "ui-business-units-lib": "static-1.9532",
  "video-components-external": "static-1.12364",
  "video-data-lib": "static-1.36022",
  "navigation-messaging": "static-1.8419",
  "collaboration-sidebar": "static-1.58980",
  "trellis-ext-dnd": "static-1.481",
  "crm-component-utils": "static-1.40102",
  "crm-properties-common-lib": "static-1.6324",
  "customer-data-properties": "static-1.52941",
  "external-options-client-types": "static-1.4423",
  "framework-data-schema-resolvers": "static-1.7327",
  "property-value-citations": "static-1.3555",
  "reference-resolvers-lite": "static-1.8542",
  "opentelemetry-web": "static-1.22",
  "beacon-keepalive-queue": "static-1.135",
  "hubspotter-http-shared-msw-handlers": "static-1.10834",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "cms-field-types": "static-1.5247",
  "content-icons-ui": "static-1.2420",
  "atom": "static-1.5513",
  "idb-keyval": "static-1.55",
  "reactive-lib": "static-1.1158",
  "breeze-artifacts-sdk": "static-1.761",
  "getting-started-shared-tasks": "static-1.19494",
  "onboarding-journeys-lib": "static-1.1169",
  "conversations-skeleton-state": "static-1.7603",
  "crm-message-bus": "static-1.44025",
  "customer-data-filters-ui-msw-helpers": "static-1.23700",
  "events-data-lib": "static-1.681",
  "FormUrlGenerator": "static-2.5152",
  "framework-builder-read-service-client": "static-1.4308",
  "hs-resources": "static-1.632",
  "multi-account-reference-resolvers": "static-1.1439",
  "onboarding-tours": "static-1.17340",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14703",
  "segments-client-types": "static-1.12043",
  "academy-common-lib": "static-1.15370",
  "dashboard-lib": "static-1.83208",
  "hubspot-prosemirror-plugins": "static-1.19206",
  "share-with-third-party-component-lib": "static-1.9146",
  "ui-asset-management-lib": "static-1.11538",
  "user-context": "static-1.5489",
  "reporting-plugins": "static-1.10918",
  "reporting-reports": "static-1.68920",
  "hubs-service-types": "static-1.1700",
  "purchase-motions-api": "static-1.6586",
  "salesImages": "static-1.690",
  "signup-constants": "static-1.19868",
  "nest": "static-1.670",
  "breeze-engine-chat-components": "static-1.1024",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.3109",
  "nudge-renderer-utils": "static-1.3428",
  "whisper-core-api": "static-1.7574",
  "bend-plugin-fail-safe": "static-1.338",
  "framework-listing-lib": "static-2.29736",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31684",
  "apps-service-types": "static-1.4082",
  "oauth-service-types": "static-1.4597",
  "signup-ui-url-generator": "static-2.8492",
  "onboarding-tours-client": "static-1.5555",
  "one-click-checkout": "static-1.691",
  "platform-infra-nav-components": "static-1.7978",
  "subscription-experience-data-types": "static-1.15388",
  "crm-record-cards-service-types": "static-1.3847",
  "location-customization-utils-lib": "static-1.10351",
  "redux-thunk": "static-2.84",
  "react-flip-move": "static-1.82",
  "ui-coaching-tips": "static-1.29534",
  "content-media-composition-data-lib": "static-1.13520",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4862",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3910",
  "seat-types-lib": "static-1.978",
  "ui-addon-opt": "static-4.8821",
  "commerce-tours-lib": "static-1.6804",
  "growth-onboarding-reliability": "static-1.5516",
  "sales-checkout-service-client": "static-1.3959",
  "data-token-picker": "static-1.17070",
  "FileManagerLib": "static-1.40412",
  "content-media-compositions": "static-2.17527",
  "media-bridge-lib": "static-1.19586",
  "chatspot-widget-iframe": "static-1.23598",
  "collaboration-sidebar-common": "static-1.3777",
  "marketing-platform-lib": "static-1.7331",
  "dnd-kit": "static-1.20",
  "card-properties-lib": "static-1.45261",
  "commerce-subscription-lib": "static-1.38026",
  "crm-actions": "static-1.6786",
  "crm-cards-sdk": "static-1.44916",
  "customer-data-properties-shared-msw-handlers": "static-1.10163",
  "customer-data-tracking": "static-1.7307",
  "trellis-migration-context": "static-1.13",
  "calling-global-api": "static-1.66077",
  "calling-internal-common": "static-1.31760",
  "calling-lifecycle-internal": "static-1.67459",
  "calling-lifecycle-messages": "static-1.59752",
  "commerce-products-lib": "static-1.10805",
  "conditional-properties-service-client": "static-1.4094",
  "crm-index-visualization-core": "static-1.4703",
  "crm-links": "static-1.6742",
  "crm-pipelines-api-client-types": "static-1.4425",
  "formula-editor": "static-1.14957",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4505",
  "meetings-icalendar-utils-lib": "static-1.1073",
  "multi-currency-client-types": "static-1.3990",
  "object-builder-ui-client": "static-1.49966",
  "pipeline-validation-client-types": "static-1.4263",
  "smart-data-capture-core": "static-1.401",
  "smart-property-lib": "static-1.8558",
  "tiered-pricing": "static-1.2169",
  "topics-actions-lib": "static-1.612",
  "trellis-ext-i18n": "static-1.1325",
  "ui-addon-form-validation": "static-1.11342",
  "zustand": "static-1.88",
  "fdsr-migration-layer": "static-1.446",
  "framework-data-schema-quick-fetch": "static-1.7232",
  "restore-request-side-panel-lib": "static-1.1952",
  "growth-data-modal": "static-1.6076",
  "growth-onboarding-confetti": "static-1.3496",
  "growth-onboarding-next-action-utils": "static-1.2919",
  "onboarding-tours-utils": "static-1.1407",
  "ui-shepherd-tracker": "static-1.8091",
  "crm-index-associations-lib": "static-1.6883",
  "academy-service-client": "static-1.4128",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40271",
  "SafeStorage": "static-1.4828",
  "video-embed": "static-1.36856",
  "redux-actions": "static-3.74",
  "EmailSignatureEditor": "static-1.25183",
  "viral-links-lib": "static-1.7514",
  "nested-table": "static-1.669",
  "timezone-utils": "static-2.5666",
  "getting-started-shared-tasks-store": "static-1.18612",
  "campaign-roi-lib": "static-1.10709",
  "campaigns-utils-lib": "static-1.3672",
  "ui-addon-calendars": "static-2.5797",
  "customer-data-views-management": "static-1.26266",
  "framework-data-table": "static-2.12777",
  "nudge-custom-ui-functions": "static-1.1684",
  "switchboard-lib": "static-1.663",
  "access-check-ui-lib": "static-1.1820",
  "app-users-service-client": "static-1.6055",
  "app-users-service-types": "static-1.5463",
  "mini-checkout-client": "static-1.27786",
  "onboarding-utils": "static-1.5809",
  "permissions-shared-i18n-strings-fe": "static-1.2142",
  "ui-coaching-tips-shared-config": "static-1.29519",
  "checkout-sdk": "static-3.24629",
  "payment-method-components": "static-1.7279",
  "touchless-buying-components": "static-1.6497",
  "upgrade-catalog-service-types": "static-1.3859",
  "edison-service-client-types": "static-1.827",
  "growth-onboarding-feedback-components": "static-1.7018",
  "audio-components": "static-1.6513",
  "FileManagerImages": "static-1.37923",
  "video-components": "static-1.14366",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.93127",
  "customer-data-sidebar": "static-2.46952",
  "enrichment-lib": "static-1.826",
  "smart-property-fill-lib": "static-1.576",
  "ui-addon-draggable-compat": "static-2.4698",
  "universal-record-utils-lib": "static-1.2285",
  "commerce-billing-lib": "static-1.20465",
  "commerce-shared-components-lib": "static-1.19498",
  "commerce-tools-ui-lib": "static-1.11258",
  "crm-fe-perf": "static-1.23331",
  "calling-error-reporting": "static-1.31767",
  "shared-worker-versioning": "static-1.11477",
  "calling-usage-tracker": "static-1.6969",
  "voice-sms-access-library": "static-1.2356",
  "commerce-permissions": "static-1.1217",
  "products-iframe-lib": "static-1.8832",
  "products-ui-components-shared-msw-handlers": "static-1.11218",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10919",
  "sales-views-client-types": "static-1.4692",
  "bark-lib": "static-1.16967",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.842",
  "data-agent-test-utils": "static-1.386",
  "data-agent-utils": "static-1.855",
  "policy-lib": "static-1.7243",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10982",
  "onboarding-data-sync-lib": "static-1.2780",
  "growth-onboarding-next-action-components": "static-1.2947",
  "user-context-client": "static-1.4945",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4950",
  "outpost": "static-1.4568",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22296",
  "sales-email-signature-service-client": "static-1.4285",
  "ts-utils-lib": "static-1.585",
  "copilot-messaging": "static-1.2326",
  "crm-export-dialog": "static-1.6711",
  "crm-index-ui-shimmer": "static-1.2914",
  "crm-view-components": "static-1.1434",
  "react-beautiful-dnd": "static-1.74",
  "customer-data-associations": "static-1.7769",
  "tasks-actions-lib": "static-1.371",
  "InboxConnectUtils": "static-4.15780",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.47076",
  "hub-http-rxjs": "static-1.872",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4424",
  "company-details-components": "static-1.6639",
  "react-performance-metrics-lib": "static-1.988",
  "pricing-pages-ui-components": "static-1.16391",
  "quote-checkout-service-types": "static-1.3891",
  "social-insights-client-types": "static-1.22870",
  "crm_universal": "static-1.22665",
  "customer-data-email": "static-1.18596",
  "card-payment-highlight-lib": "static-1.38237",
  "commerce-contract-lib": "static-1.13701",
  "invoices-highlight-card-lib": "static-1.56084",
  "orders-highlight-card-lib": "static-1.22436",
  "products-highlight-card-lib": "static-1.19088",
  "quotes-highlight-card-lib": "static-1.73024",
  "crm-source-interpretation-lib": "static-1.5762",
  "enrichment-settings-lib": "static-1.171",
  "data-agent-usage-based-billing": "static-1.30",
  "crm-object-search-query-utilities": "static-1.10399",
  "utility-belt": "static-1.2971",
  "payments-enrollment-embed-lib": "static-1.24129",
  "stripe-embedded-components": "static-1.8182",
  "customer-data-rte": "static-1.33835",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6471",
  "payments-post-enroll-local-storage-lib": "static-1.5538",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39114",
  "calling-orchestration-schema": "static-1.37133",
  "react-reducer-toolkit": "static-1.16602",
  "meetings-connect-utils-lib": "static-1.8052",
  "hub-http-contrib": "static-1.3464",
  "ui-addon-sales-email": "static-1.5637",
  "access-control-lib": "static-1.10864",
  "EmailComponents": "static-1.55783",
  "EmailData": "static-1.54461",
  "messaging-base-table-lib": "static-1.737",
  "redux-less": "static-2.9896",
  "company-details-service-types": "static-1.4379",
  "segments-query-core": "static-1.1866",
  "pricing-pages-api": "static-1.16256",
  "sequences-lib": "static-1.8711",
  "ui-gdpr-components": "static-1.10651",
  "products-ui-components": "static-1.41323",
  "reporting-enablement": "static-1.24097",
  "accounting-integrations-ui-components": "static-1.7738",
  "invoices-ui-lib": "static-1.56100",
  "commerce-products-api": "static-1.2864",
  "invoices-iframe-lib": "static-1.58158",
  "quotes-modal-lib": "static-1.103702",
  "quotes-ui-lib": "static-1.81745",
  "stripe-connect-js": "static-1.82",
  "draft-content-plugins": "static-1.29093",
  "ContentComponents": "static-2.72346",
  "ContentData": "static-1.69465",
  "marketing-email-service-types": "static-1.2193",
  "messaging-editing-lib": "static-1.47394",
  "messaging-usage-based-billing-components-lib": "static-1.2256",
  "automation-ui-source-apps": "static-1.19912",
  "automation-ui-types": "static-1.20830",
  "messaging-types-lib": "static-1.47131",
  "onboarding-settings-client": "static-1.4946",
  "sequences-client-types-lib": "static-1.8568",
  "commerce-tax-lib": "static-1.972",
  "price-books-api": "static-1.1970",
  "price-books-components": "static-1.2028",
  "property-description-translator": "static-1.4255",
  "ramp-editor": "static-1.1103",
  "data-quality-ui-library": "static-1.14195",
  "report-customization-components": "static-1.14142",
  "reporting-filters": "static-1.1228",
  "reporting-insights-lib": "static-1.2855",
  "commerce-analytics-service-client": "static-1.3947",
  "totals-ui-components": "static-1.24501",
  "SalesContentIndexUI": "static-3.9694",
  "advanced-menus-core": "static-1.15754",
  "advanced-menus-lib": "static-1.12517",
  "automation-ui-ubb": "static-1.6746",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7776",
  "data-token-views": "static-1.17051",
  "forms-utils-lib": "static-1.13276",
  "payments-embed-points-lib": "static-1.13787",
  "react-tinymce": "static-1.56203",
  "simple-menus-core": "static-1.15753",
  "simple-menus-lib": "static-1.17270",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55329",
  "tinymce-data": "static-1.41414",
  "tinymce-plugins": "static-1.58443",
  "tinymce-themes": "static-1.57299",
  "ui-brand-identity-lib": "static-1.16856",
  "ui-memberships-settings-lib": "static-1.35110",
  "videoconference-integration-components": "static-1.7472",
  "automation-applications-service-types": "static-1.3704",
  "automation-platform-service-types": "static-1.2715",
  "content-whatsapp-service-types": "static-1.659",
  "ContentEditorUI": "static-2.78164",
  "short-messages-app-service-client": "static-1.4362",
  "web-interactives-components": "static-1.14430",
  "web-interactives-data": "static-1.14431",
  "messaging-shared-utils-lib": "static-1.1705",
  "messaging-user-info-utils-lib": "static-1.1875",
  "email-portal-health-service-types": "static-1.1416",
  "line-items-api": "static-1.1273",
  "merge-modal-lib": "static-1.12951",
  "commerce-totals-service-types": "static-1.4113",
  "FireAlarmUi": "static-1.4821",
  "sales-templates-service-types-lib": "static-1.4465",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22766",
  "automation-ui-usage-tracking": "static-1.22229",
  "data-studio-ubb": "static-1.3747",
  "interframe": "static-3.5176",
  "layout-dnd-components": "static-1.13160",
  "layout-dnd-utils": "static-1.12135",
  "NamespacedHubStyle": "static-2.9342",
  "campaigns-lib": "static-1.27844",
  "content-management-data-lib": "static-1.6169",
  "copilot-plugins": "static-1.12048",
  "cta-picker": "static-1.37175",
  "customer-agent-discovery-components-lib": "static-1.4193",
  "editor-components": "static-1.13830",
  "editor-iframe-lib": "static-1.8954",
  "error-messaging-js": "static-1.5571",
  "FormsCommonComponents": "static-1.86772",
  "layout-data-lib": "static-1.10460",
  "pictos": "static-7.195",
  "react-transition-group": "static-2.77",
  "redux-request-state": "static-1.11074",
  "SharedLegalStrings": "static-1.2164",
  "smart-content-core": "static-1.43394",
  "smart-content-lib": "static-1.44047",
  "social-composer-lib": "static-1.60531",
  "structured-content-lib": "static-1.26130",
  "theme-previewer-lib": "static-1.54102",
  "tinymce-copilot": "static-1.17397",
  "xray-recommendation-lib": "static-1.8410",
  "automation-ui-routing": "static-1.22187",
  "sql-reporting-client-types": "static-1.5990",
  "attribution-lib": "static-1.42955",
  "voice-agents-components": "static-1.4010",
  "forms-ai-lib": "static-1.4925",
  "codemirror-dlb": "static-1.59723",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6881",
  "calling-orchestration-shared-library": "static-1.36908"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13445",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1075",
  "client-types": "/client-types/static-1.507",
  "data-fetching-client": "/data-fetching-client/static-1.10079",
  "foundations-components": "/foundations-components/static-1.8684",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1709",
  "foundations-theming": "/foundations-theming/static-1.4920",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.93",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8473",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10836",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11928",
  "I18n": "/I18n/static-7.1698",
  "jasmine-runner": "/jasmine-runner/static-1.6886",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.842",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13508",
  "quartz": "/quartz/static-1.7613",
  "react-dlb": "/react-dlb/static-1.93",
  "react-rhumb": "/react-rhumb/static-1.17170",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3287",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11177",
  "reselect": "/reselect/static-3.16",
  "settings-ui-lib": "/settings-ui-lib/static-1.12965",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7793",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11580",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9963",
  "unified-auth": "/unified-auth/static-1.1168",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1450",
  "usage-tracker": "/usage-tracker/static-1.7748",
  "usage-tracker-core": "/usage-tracker-core/static-1.7598",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8481",
  "hub-http": "/hub-http/static-1.6644",
  "integrations-lib": "/integrations-lib/static-1.17333",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20985",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.971",
  "property-management-iframe": "/property-management-iframe/static-1.14384",
  "quartz-config": "/quartz-config/static-1.1391",
  "quartz-core": "/quartz-core/static-1.6832",
  "quartz-routing": "/quartz-routing/static-1.1043",
  "quick-fetch": "/quick-fetch/static-1.4205",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5106",
  "ts-schema": "/ts-schema/static-1.4375",
  "ui-universal-auth": "/ui-universal-auth/static-1.9654",
  "UIComponents": "/UIComponents/static-3.8874",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3890",
  "quartz-webpack": "/quartz-webpack/static-1.3837",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.691",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9952",
  "codemirror": "/codemirror/static-5.106",
  "foundations-assets": "/foundations-assets/static-1.5321",
  "pulse": "/pulse/static-1.1077",
  "react-codemirror": "/react-codemirror/static-1.11075",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.871",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4953",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2636",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9860",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.96",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5636",
  "react-virtualized": "/react-virtualized/static-2.111",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2997",
  "ui-fonts": "/ui-fonts/static-1.1190",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3403",
  "foundations-theming-base": "/foundations-theming-base/static-1.3905",
  "stylex": "/stylex/static-1.46",
  "HeadJS": "/HeadJS/static-2.817",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3584",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.24",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4743",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9059",
  "ai-rendering-library": "/ai-rendering-library/static-1.11334",
  "chirp-fetch": "/chirp-fetch/static-1.2338",
  "connections-embed-lib": "/connections-embed-lib/static-1.1686",
  "copilot-toolkit": "/copilot-toolkit/static-1.12076",
  "feedback-loader": "/feedback-loader/static-1.30001",
  "laboratory-lib": "/laboratory-lib/static-3.7585",
  "marketplace-embed": "/marketplace-embed/static-1.23136",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10880",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20940",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15155",
  "sanitize-text": "/sanitize-text/static-1.8592",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6162",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5434",
  "wootric-nps": "/wootric-nps/static-1.7276",
  "quartz-head": "/quartz-head/static-1.1278",
  "web-vitals": "/web-vitals/static-1.19",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5023",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4577",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2799",
  "reporting-data": "/reporting-data/static-1.69244",
  "cssUtils": "/cssUtils/static-1.1056",
  "flux-actions": "/flux-actions/static-1.380",
  "react-colorpicker": "/react-colorpicker/static-2.10646",
  "react-dnd-compat": "/react-dnd-compat/static-1.5044",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10806",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7738",
  "icons": "/icons/static-2.699",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19517",
  "storybook-react": "/storybook-react/static-1.44",
  "trellis-story-utils": "/trellis-story-utils/static-1.4936",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6167",
  "quartz-i18n": "/quartz-i18n/static-1.1288",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.700",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1827",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.218",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1265",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.426",
  "slack-ui-library": "/slack-ui-library/static-1.10833",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.792",
  "fsm": "/fsm/static-1.4194",
  "customer-data-objects": "/customer-data-objects/static-1.8129",
  "property-translator": "/property-translator/static-1.5814",
  "hs-locale-management": "/hs-locale-management/static-1.375",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8353",
  "hs-promise-utils": "/hs-promise-utils/static-1.6028",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5314",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14748",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6048",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8198",
  "sanitize": "/sanitize/static-1.4909",
  "superstore": "/superstore/static-1.5193",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10710",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8520",
  "hub-http-janus": "/hub-http-janus/static-1.902",
  "hubspotter-http": "/hubspotter-http/static-1.4950",
  "immutable-less": "/immutable-less/static-1.5087",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18392",
  "nav-meta": "/nav-meta/static-1.30729",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18525",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1482",
  "ai-studio-lib": "/ai-studio-lib/static-1.12688",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19214",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.659",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9512",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8390",
  "ui-product-approvals": "/ui-product-approvals/static-1.29587",
  "ui-tool-access": "/ui-tool-access/static-1.10593",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4125",
  "property-management-common": "/property-management-common/static-1.6672",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.222",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.600",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.597",
  "quartz-auth": "/quartz-auth/static-1.1288",
  "quartz-test": "/quartz-test/static-1.1288",
  "quartz-tracking": "/quartz-tracking/static-1.992",
  "trellis-components": "/trellis-components/static-1.3016",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.516",
  "HubStyle": "/HubStyle/static-2.12235",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23607",
  "ContentUtils": "/ContentUtils/static-1.69390",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13464",
  "sassPrefix": "/sassPrefix/static-1.324",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.1982",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.580",
  "event-emitter": "/event-emitter/static-1.1396",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5874",
  "magpie-types": "/magpie-types/static-1.5334",
  "stylex-utils": "/stylex-utils/static-1.168",
  "trellis-theming": "/trellis-theming/static-1.1422",
  "avatar-components": "/avatar-components/static-1.2919",
  "breeze-engine-core": "/breeze-engine-core/static-1.1324",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.994",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41265",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13601",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.237",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15910",
  "ExportDialog": "/ExportDialog/static-6.10806",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.426",
  "highlight.js": "/highlight.js/static-1.90",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.839",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.44",
  "reporting-action-components": "/reporting-action-components/static-1.42308",
  "reporting-snowflake": "/reporting-snowflake/static-1.57860",
  "reporting-ui-components": "/reporting-ui-components/static-2.66513",
  "reporting-visualizations": "/reporting-visualizations/static-1.61318",
  "trial-components-library": "/trial-components-library/static-1.14316",
  "ui-addon-teams": "/ui-addon-teams/static-1.21971",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.676",
  "navigation-components": "/navigation-components/static-1.19092",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2046",
  "simple-logging-lib": "/simple-logging-lib/static-1.3488",
  "nudge-client-utils": "/nudge-client-utils/static-1.3352",
  "fail-safe": "/fail-safe/static-1.387",
  "app-governance-lib": "/app-governance-lib/static-1.2625",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10974",
  "purchase-motions-components": "/purchase-motions-components/static-1.6583",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10669",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6165",
  "usage-tracker-public": "/usage-tracker-public/static-1.7559",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3753",
  "persist-promise": "/persist-promise/static-1.4139",
  "reference-resolvers": "/reference-resolvers/static-1.8614",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4351",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.773",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3444",
  "final-form": "/final-form/static-1.82",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "simple-data-table": "/simple-data-table/static-1.3760",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "onboarding-scopes": "/onboarding-scopes/static-1.6888",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5183",
  "content-assistance-lib": "/content-assistance-lib/static-1.8366",
  "content-media-capture": "/content-media-capture/static-1.5716",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10268",
  "emoji-mart": "/emoji-mart/static-3.6",
  "file-manager-components": "/file-manager-components/static-1.24772",
  "growth-payments-core": "/growth-payments-core/static-1.26433",
  "knowledge-content-types": "/knowledge-content-types/static-1.8722",
  "PatternValidationJS": "/PatternValidationJS/static-1.3321",
  "payment-link-components": "/payment-link-components/static-1.24374",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20494",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10300",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9532",
  "video-components-external": "/video-components-external/static-1.12364",
  "video-data-lib": "/video-data-lib/static-1.36022",
  "navigation-messaging": "/navigation-messaging/static-1.8419",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58980",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.481",
  "crm-component-utils": "/crm-component-utils/static-1.40102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6324",
  "customer-data-properties": "/customer-data-properties/static-1.52941",
  "external-options-client-types": "/external-options-client-types/static-1.4423",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7327",
  "property-value-citations": "/property-value-citations/static-1.3555",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8542",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.135",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10834",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "cms-field-types": "/cms-field-types/static-1.5247",
  "content-icons-ui": "/content-icons-ui/static-1.2420",
  "atom": "/atom/static-1.5513",
  "idb-keyval": "/idb-keyval/static-1.55",
  "reactive-lib": "/reactive-lib/static-1.1158",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.761",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19494",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1169",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7603",
  "crm-message-bus": "/crm-message-bus/static-1.44025",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23700",
  "events-data-lib": "/events-data-lib/static-1.681",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5152",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4308",
  "hs-resources": "/hs-resources/static-1.632",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1439",
  "onboarding-tours": "/onboarding-tours/static-1.17340",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14703",
  "segments-client-types": "/segments-client-types/static-1.12043",
  "academy-common-lib": "/academy-common-lib/static-1.15370",
  "dashboard-lib": "/dashboard-lib/static-1.83208",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19206",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9146",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11538",
  "user-context": "/user-context/static-1.5489",
  "reporting-plugins": "/reporting-plugins/static-1.10918",
  "reporting-reports": "/reporting-reports/static-1.68920",
  "hubs-service-types": "/hubs-service-types/static-1.1700",
  "purchase-motions-api": "/purchase-motions-api/static-1.6586",
  "salesImages": "/salesImages/static-1.690",
  "signup-constants": "/signup-constants/static-1.19868",
  "nest": "/nest/static-1.670",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1024",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3109",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3428",
  "whisper-core-api": "/whisper-core-api/static-1.7574",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.338",
  "framework-listing-lib": "/framework-listing-lib/static-2.29736",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31684",
  "apps-service-types": "/apps-service-types/static-1.4082",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8492",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5555",
  "one-click-checkout": "/one-click-checkout/static-1.691",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7978",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15388",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3847",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10351",
  "redux-thunk": "/redux-thunk/static-2.84",
  "react-flip-move": "/react-flip-move/static-1.82",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29534",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13520",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4862",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3910",
  "seat-types-lib": "/seat-types-lib/static-1.978",
  "ui-addon-opt": "/ui-addon-opt/static-4.8821",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6804",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5516",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3959",
  "data-token-picker": "/data-token-picker/static-1.17070",
  "FileManagerLib": "/FileManagerLib/static-1.40412",
  "content-media-compositions": "/content-media-compositions/static-2.17527",
  "media-bridge-lib": "/media-bridge-lib/static-1.19586",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23598",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3777",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7331",
  "dnd-kit": "/dnd-kit/static-1.20",
  "card-properties-lib": "/card-properties-lib/static-1.45261",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38026",
  "crm-actions": "/crm-actions/static-1.6786",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44916",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10163",
  "customer-data-tracking": "/customer-data-tracking/static-1.7307",
  "trellis-migration-context": "/trellis-migration-context/static-1.13",
  "calling-global-api": "/calling-global-api/static-1.66077",
  "calling-internal-common": "/calling-internal-common/static-1.31760",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67459",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59752",
  "commerce-products-lib": "/commerce-products-lib/static-1.10805",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4094",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4703",
  "crm-links": "/crm-links/static-1.6742",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4425",
  "formula-editor": "/formula-editor/static-1.14957",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4505",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1073",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3990",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49966",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4263",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.401",
  "smart-property-lib": "/smart-property-lib/static-1.8558",
  "tiered-pricing": "/tiered-pricing/static-1.2169",
  "topics-actions-lib": "/topics-actions-lib/static-1.612",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1325",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11342",
  "zustand": "/zustand/static-1.88",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.446",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7232",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1952",
  "growth-data-modal": "/growth-data-modal/static-1.6076",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3496",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2919",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1407",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8091",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6883",
  "academy-service-client": "/academy-service-client/static-1.4128",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40271",
  "SafeStorage": "/SafeStorage/static-1.4828",
  "video-embed": "/video-embed/static-1.36856",
  "redux-actions": "/redux-actions/static-3.74",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25183",
  "viral-links-lib": "/viral-links-lib/static-1.7514",
  "nested-table": "/nested-table/static-1.669",
  "timezone-utils": "/timezone-utils/static-2.5666",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18612",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10709",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3672",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5797",
  "customer-data-views-management": "/customer-data-views-management/static-1.26266",
  "framework-data-table": "/framework-data-table/static-2.12777",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1684",
  "switchboard-lib": "/switchboard-lib/static-1.663",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1820",
  "app-users-service-client": "/app-users-service-client/static-1.6055",
  "app-users-service-types": "/app-users-service-types/static-1.5463",
  "mini-checkout-client": "/mini-checkout-client/static-1.27786",
  "onboarding-utils": "/onboarding-utils/static-1.5809",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2142",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29519",
  "checkout-sdk": "/checkout-sdk/static-3.24629",
  "payment-method-components": "/payment-method-components/static-1.7279",
  "touchless-buying-components": "/touchless-buying-components/static-1.6497",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3859",
  "edison-service-client-types": "/edison-service-client-types/static-1.827",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7018",
  "audio-components": "/audio-components/static-1.6513",
  "FileManagerImages": "/FileManagerImages/static-1.37923",
  "video-components": "/video-components/static-1.14366",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.93127",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46952",
  "enrichment-lib": "/enrichment-lib/static-1.826",
  "smart-property-fill-lib": "/smart-property-fill-lib/static-1.576",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4698",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2285",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20465",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19498",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11258",
  "crm-fe-perf": "/crm-fe-perf/static-1.23331",
  "calling-error-reporting": "/calling-error-reporting/static-1.31767",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11477",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6969",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2356",
  "commerce-permissions": "/commerce-permissions/static-1.1217",
  "products-iframe-lib": "/products-iframe-lib/static-1.8832",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11218",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10919",
  "sales-views-client-types": "/sales-views-client-types/static-1.4692",
  "bark-lib": "/bark-lib/static-1.16967",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.842",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.386",
  "data-agent-utils": "/data-agent-utils/static-1.855",
  "policy-lib": "/policy-lib/static-1.7243",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10982",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2780",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2947",
  "user-context-client": "/user-context-client/static-1.4945",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4950",
  "outpost": "/outpost/static-1.4568",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22296",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4285",
  "ts-utils-lib": "/ts-utils-lib/static-1.585",
  "copilot-messaging": "/copilot-messaging/static-1.2326",
  "crm-export-dialog": "/crm-export-dialog/static-1.6711",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2914",
  "crm-view-components": "/crm-view-components/static-1.1434",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.74",
  "customer-data-associations": "/customer-data-associations/static-1.7769",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.371",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15780",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.47076",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.872",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4424",
  "company-details-components": "/company-details-components/static-1.6639",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.988",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16391",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3891",
  "social-insights-client-types": "/social-insights-client-types/static-1.22870",
  "crm_universal": "/crm_universal/static-1.22665",
  "customer-data-email": "/customer-data-email/static-1.18596",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38237",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13701",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56084",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22436",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19088",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.73024",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5762",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.171",
  "data-agent-usage-based-billing": "/data-agent-usage-based-billing/static-1.30",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10399",
  "utility-belt": "/utility-belt/static-1.2971",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24129",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8182",
  "customer-data-rte": "/customer-data-rte/static-1.33835",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6471",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5538",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39114",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37133",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16602",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8052",
  "hub-http-contrib": "/hub-http-contrib/static-1.3464",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5637",
  "access-control-lib": "/access-control-lib/static-1.10864",
  "EmailComponents": "/EmailComponents/static-1.55783",
  "EmailData": "/EmailData/static-1.54461",
  "messaging-base-table-lib": "/messaging-base-table-lib/static-1.737",
  "redux-less": "/redux-less/static-2.9896",
  "company-details-service-types": "/company-details-service-types/static-1.4379",
  "segments-query-core": "/segments-query-core/static-1.1866",
  "pricing-pages-api": "/pricing-pages-api/static-1.16256",
  "sequences-lib": "/sequences-lib/static-1.8711",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
  "products-ui-components": "/products-ui-components/static-1.41323",
  "reporting-enablement": "/reporting-enablement/static-1.24097",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7738",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.56100",
  "commerce-products-api": "/commerce-products-api/static-1.2864",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58158",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103702",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81745",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "draft-content-plugins": "/draft-content-plugins/static-1.29093",
  "ContentComponents": "/ContentComponents/static-2.72346",
  "ContentData": "/ContentData/static-1.69465",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2193",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47394",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2256",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19912",
  "automation-ui-types": "/automation-ui-types/static-1.20830",
  "messaging-types-lib": "/messaging-types-lib/static-1.47131",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4946",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8568",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.972",
  "price-books-api": "/price-books-api/static-1.1970",
  "price-books-components": "/price-books-components/static-1.2028",
  "property-description-translator": "/property-description-translator/static-1.4255",
  "ramp-editor": "/ramp-editor/static-1.1103",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.14195",
  "report-customization-components": "/report-customization-components/static-1.14142",
  "reporting-filters": "/reporting-filters/static-1.1228",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2855",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3947",
  "totals-ui-components": "/totals-ui-components/static-1.24501",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9694",
  "advanced-menus-core": "/advanced-menus-core/static-1.15754",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12517",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6746",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7776",
  "data-token-views": "/data-token-views/static-1.17051",
  "forms-utils-lib": "/forms-utils-lib/static-1.13276",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13787",
  "react-tinymce": "/react-tinymce/static-1.56203",
  "simple-menus-core": "/simple-menus-core/static-1.15753",
  "simple-menus-lib": "/simple-menus-lib/static-1.17270",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55329",
  "tinymce-data": "/tinymce-data/static-1.41414",
  "tinymce-plugins": "/tinymce-plugins/static-1.58443",
  "tinymce-themes": "/tinymce-themes/static-1.57299",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16856",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35110",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7472",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3704",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2715",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.659",
  "ContentEditorUI": "/ContentEditorUI/static-2.78164",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4362",
  "web-interactives-components": "/web-interactives-components/static-1.14430",
  "web-interactives-data": "/web-interactives-data/static-1.14431",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1705",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1875",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1416",
  "line-items-api": "/line-items-api/static-1.1273",
  "merge-modal-lib": "/merge-modal-lib/static-1.12951",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4113",
  "FireAlarmUi": "/FireAlarmUi/static-1.4821",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4465",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22766",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22229",
  "data-studio-ubb": "/data-studio-ubb/static-1.3747",
  "interframe": "/interframe/static-3.5176",
  "layout-dnd-components": "/layout-dnd-components/static-1.13160",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12135",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9342",
  "campaigns-lib": "/campaigns-lib/static-1.27844",
  "content-management-data-lib": "/content-management-data-lib/static-1.6169",
  "copilot-plugins": "/copilot-plugins/static-1.12048",
  "cta-picker": "/cta-picker/static-1.37175",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4193",
  "editor-components": "/editor-components/static-1.13830",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8954",
  "error-messaging-js": "/error-messaging-js/static-1.5571",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86772",
  "layout-data-lib": "/layout-data-lib/static-1.10460",
  "pictos": "/pictos/static-7.195",
  "react-transition-group": "/react-transition-group/static-2.77",
  "redux-request-state": "/redux-request-state/static-1.11074",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2164",
  "smart-content-core": "/smart-content-core/static-1.43394",
  "smart-content-lib": "/smart-content-lib/static-1.44047",
  "social-composer-lib": "/social-composer-lib/static-1.60531",
  "structured-content-lib": "/structured-content-lib/static-1.26130",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.54102",
  "tinymce-copilot": "/tinymce-copilot/static-1.17397",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8410",
  "automation-ui-routing": "/automation-ui-routing/static-1.22187",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5990",
  "attribution-lib": "/attribution-lib/static-1.42955",
  "voice-agents-components": "/voice-agents-components/static-1.4010",
  "forms-ai-lib": "/forms-ai-lib/static-1.4925",
  "codemirror-dlb": "/codemirror-dlb/static-1.59723",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6881",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.36908"
}
};
